// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-action-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.compact-confirm-action{
  
    width: 95%;
   height: 95%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}
.confirm-action-titulo{
    font-size: var(--font-size-large);
    font-weight: bold;
    border-bottom: 1px solid rgba(128, 128, 128, 0.349);
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--main-color);
}
.confirm-action-body{
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.confirm-action-footer{
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}       
.cont-msg-alert-confirm-action{
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
   
}
.cont-msg-confirm-action{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
   
}
.compact-msg-alert-confirm-action{
    width: 90%;
    height: 80%;
    border: 2px solid rgb(214, 214, 27);
    background-color:rgba(255, 255, 151, 0.589);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    text-align: center;
    font-size: var(--font-size-medium);
    color: var(--txt-color);
}
.compact-msg-confirm-action{
    width: 90%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    font-size: var(--font-size-medium);
    color: var(--txt-color);
}
.cont-datos-confirm-action{
    width: 100%;
    height: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: auto;
}
.compact-datos-confirm-action{
   width: 80%;
  height: 90%;
  display: flex;
  justify-content: start;
  align-items: start;
  text-align: start;
  flex-direction: column;
  color: var(--txt-color);
}
.row-change-confirm-action{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}
.label-confirm-action-title{
    font-size: var(--font-size-medium);
    font-weight: bold;
    margin-right: 10px;
    color: var(--third-color);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: start;
width: 33%;
}
.change-values-confirm-action{
    font-size: var(--font-size-medium);
    color: var(--txt-color);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 67%;
}
.old-value-confirm-action{
    
    margin-right: 10px;
    color: var(--error-color);
    width: 47%;
    display: flex  ;
    justify-content: center;
    align-items: center;
}
.arrow-change-confirm-action{
    font-size: var(--font-size-large);
    margin-right: 10px;
    color: var(--txt-color);
    width: 6%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.new-value-confirm-action{
    color: var(--green);
    width: 47%;
    display: flex  ;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/cis-components/ModalCreate/ConfirmAction.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,UAAU;GACX,WAAW;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,mDAAmD;IACnD,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;AACA;GACG,UAAU;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B,UAAU;AACV;AACA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;AACA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".confirm-action-container{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.compact-confirm-action{\r\n  \r\n    width: 95%;\r\n   height: 95%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n.confirm-action-titulo{\r\n    font-size: var(--font-size-large);\r\n    font-weight: bold;\r\n    border-bottom: 1px solid rgba(128, 128, 128, 0.349);\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--main-color);\r\n}\r\n.confirm-action-body{\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n.confirm-action-footer{\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n}       \r\n.cont-msg-alert-confirm-action{\r\n    width: 100%;\r\n    height: 15%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   \r\n}\r\n.cont-msg-confirm-action{\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n   \r\n}\r\n.compact-msg-alert-confirm-action{\r\n    width: 90%;\r\n    height: 80%;\r\n    border: 2px solid rgb(214, 214, 27);\r\n    background-color:rgba(255, 255, 151, 0.589);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n}\r\n.compact-msg-confirm-action{\r\n    width: 90%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n}\r\n.cont-datos-confirm-action{\r\n    width: 100%;\r\n    height: 75%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n}\r\n.compact-datos-confirm-action{\r\n   width: 80%;\r\n  height: 90%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: start;\r\n  text-align: start;\r\n  flex-direction: column;\r\n  color: var(--txt-color);\r\n}\r\n.row-change-confirm-action{\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n.label-confirm-action-title{\r\n    font-size: var(--font-size-medium);\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n    color: var(--third-color);\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: start;\r\nwidth: 33%;\r\n}\r\n.change-values-confirm-action{\r\n    font-size: var(--font-size-medium);\r\n    color: var(--txt-color);\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 67%;\r\n}\r\n.old-value-confirm-action{\r\n    \r\n    margin-right: 10px;\r\n    color: var(--error-color);\r\n    width: 47%;\r\n    display: flex  ;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.arrow-change-confirm-action{\r\n    font-size: var(--font-size-large);\r\n    margin-right: 10px;\r\n    color: var(--txt-color);\r\n    width: 6%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.new-value-confirm-action{\r\n    color: var(--green);\r\n    width: 47%;\r\n    display: flex  ;\r\n    justify-content: center;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
